import { render, staticRenderFns } from "./data-down.vue?vue&type=template&id=5076b2b6&"
import script from "./data-down.vue?vue&type=script&lang=js&"
export * from "./data-down.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports